export const folderPlaceholderIconPath = 'assets/img/placeholders/folder-icon.webp';
